import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeConsultantCianChat } from '../../actions/consultantCianChat/actions';
import { ConsultantChatPopup } from '../../components/ConsultantChatPopup';
import { useConsultantChatUrl } from '../../hooks/consultantChat';
import { isConsultantChatOpenedSelector } from '../../selectors/consultantChat';

export const ConsultantChatPopupContainer: React.FC = () => {
  const dispatch = useDispatch();

  const isChatOpened = useSelector(isConsultantChatOpenedSelector);
  const chatUrl = useConsultantChatUrl({ isChatOpened });

  const handleClose = React.useCallback(() => dispatch(closeConsultantCianChat()), [dispatch]);

  if (!isChatOpened) {
    return null;
  }

  return <ConsultantChatPopup url={chatUrl} onClose={handleClose} />;
};
